import type React from 'react';
import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';
import { PageLoading } from '@/app/components/page-loading.tsx';
import RepresentativeList from './list/representative-list.tsx';

const LazyReps = lazy(() => import('././Representative.tsx'));

const Representative = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode }) => {
  return (
    <Suspense fallback={<PageLoading />}>
      <LazyReps {...props} />
    </Suspense>
  );
};

export const repsRoute = {
  path: '/representative',
  element: <Representative />,
  children: [
    {
      path: '',
      element: <RepresentativeList />,
    },
  ],
} as RouteObject;

export default Representative;
